<template>
  <RoleGate minLevel="manager" :showWhenDenied="true">
    <div class="settings-form">
      <div class="form-grid">
        <!-- Nome da Empresa -->
        <div class="form-group">
          <label>Nome da Empresa</label>
          <div class="input-wrapper">
            <i class="bi bi-buildings icon"></i>
            <input type="text" class="form-control" v-model="companyData.companyName" placeholder="Razão Social" />
          </div>
        </div>

        <!-- Nome Fantasia -->
        <div class="form-group">
          <label>Nome Fantasia</label>
          <div class="input-wrapper">
            <i class="bi bi-shop icon"></i>
            <input type="text" class="form-control" v-model="companyData.tradeName" placeholder="Nome Fantasia" required />
          </div>
        </div>

        <!-- CNPJ -->
        <div class="form-group">
          <label>CNPJ</label>
          <div class="input-wrapper">
            <i class="bi bi-file-earmark-text icon"></i>
            <input type="text" class="form-control" v-model="companyData.cnpj" placeholder="00.000.000/0000-00" required />
          </div>
        </div>

        <!-- Telefone -->
        <div class="form-group">
          <label>Telefone Comercial</label>
          <div class="input-wrapper">
            <i class="bi bi-telephone text-primary icon"></i>
            <input type="text" class="form-control" v-model="companyData.phoneNumber" placeholder="(00) 0000-0000" required />
          </div>
        </div>
      </div>

      <hr class="form-divider" />

      <h3 class="section-title">Dados da Licença</h3>
      <div class="form-grid">
        <!-- Plano -->
        <div class="form-group">
          <label>Plano Contratado</label>
          <div class="input-wrapper locked">
            <i class="bi bi-journal-bookmark-fill text-warning icon"></i>
            <input type="text" class="form-control" :value="getTranslatedPlan(companyData.plano)" disabled />
          </div>
        </div>

        <!-- Qnt Prestadores -->
        <div class="form-group">
          <label>Limite de Prestadores</label>
          <div class="input-wrapper locked">
            <i class="bi bi-people icon"></i>
            <input type="text" class="form-control" v-model="companyData.qntPrestadores" disabled />
          </div>
        </div>

        <!-- Qnt Acessos -->
        <div class="form-group">
          <label>Limite de Acessos</label>
          <div class="input-wrapper locked">
            <i class="bi bi-laptop icon"></i>
            <input type="text" class="form-control" v-model="companyData.qntAcessos" disabled />
          </div>
        </div>
      </div>
      
      <div class="form-actions mt-4">
        <BotaoSalvarComponent @click="postForm" />
      </div>
    </div>
  </RoleGate>
</template>

<script setup>
import axios from '@/axios.js';
import BotaoSalvarComponent from './ui/BotaoSalvar.vue';
import { showToast } from '@/eventBus.js';
import RoleGate from './RoleGate.vue';

const planTranslation = {
    BASIC: 'Básico',
    INTERMEDIARY: 'Intermediário',
    PREMIUM: 'Premium',
    default: 'Não Definido' 
};

const getTranslatedPlan = (planKey) => {
    return planTranslation[planKey] || planTranslation.default; 
};

const props = defineProps({
    companyData: { type: Object, required: true },
});

function postForm() {
    axios.put(`/api/company/edit`, props.companyData)
        .then(response => {
            showToast(response.data.message);
        }).catch(error => {
            showToast(error?.response?.data?.data || "Erro ao salvar os componentes.");
        });
}
</script>

<style scoped>
/* V2 Form Layout Standard */
.settings-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.section-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #334155;
  margin: 0.5rem 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.form-group label {
  font-weight: 600;
  color: #475569;
  font-size: 0.9rem;
}

.input-wrapper {
  display: flex;
  align-items: center;
  background-color: #F8FAFC;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  transition: all 0.2s ease;
}

.input-wrapper:focus-within {
  border-color: #DF523A;
  box-shadow: 0 0 0 3px rgba(223, 82, 58, 0.1);
  background-color: #FFFFFF;
}

.input-wrapper.locked {
  background-color: #F1F5F9;
  cursor: not-allowed;
  opacity: 0.8;
}

.input-wrapper .icon {
  font-size: 1.15rem;
  color: #94A3B8;
  margin-right: 0.75rem;
}

.form-control {
  flex: 1;
  background: transparent;
  border: none;
  color: #1E293B;
  font-size: 0.95rem;
  font-family: inherit;
  font-weight: 500;
  padding: 0.25rem 0;
  outline: none;
}

.form-control::placeholder {
  color: #CBD5E1;
  font-weight: 400;
}

.form-control:disabled {
  color: #64748B;
  cursor: not-allowed;
}

.form-divider {
  border: 0;
  border-top: 1px dashed #E2E8F0;
  margin: 1.5rem 0;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
}

/* Mapping generic bootstrap colors */
.text-primary { color: #3B82F6 !important; }
.text-warning { color: #F59E0B !important; }

@media (max-width: 767.98px) {
  .form-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
}
</style>
